module.exports = {
	"job": {
		"lang": "en-US",
		"user_id": 46548,
		"name": "dog_adoption_audio.wav",
		"duration": 182,
		"created_at": "Fri Jul 13 17:13:20 2018",
		"id": 8743576
	},
	"speakers": [
		{
			"duration": "171.27",
			"confidence": null,
			"name": "M2",
			"time": "11.44"
		}
	],
	"words": [
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "Today's",
			"time": "11.44"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "video",
			"time": "11.83"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "was",
			"time": "12.58"
		},
		{
			"duration": "0.96",
			"confidence": "1.000",
			"name": "requested",
			"time": "12.91"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "14.08"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "14.29"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "thought",
			"time": "14.41"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "14.65"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "14.77"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "was",
			"time": "14.86"
		},
		{
			"duration": "0.19",
			"confidence": "0.780",
			"name": "a",
			"time": "15.03"
		},
		{
			"duration": "0.44",
			"confidence": "0.780",
			"name": "really",
			"time": "15.22"
		},
		{
			"duration": "0.44",
			"confidence": "1.000",
			"name": "great",
			"time": "15.71"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "request",
			"time": "16.18"
		},
		{
			"duration": "0.11",
			"confidence": "0.950",
			"name": "and",
			"time": "17.08"
		},
		{
			"duration": "0.08",
			"confidence": "0.920",
			"name": "I",
			"time": "17.20"
		},
		{
			"duration": "0.09",
			"confidence": "0.710",
			"name": "had",
			"time": "17.28"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "been",
			"time": "17.37"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "asked",
			"time": "17.56"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "to",
			"time": "18.04"
		},
		{
			"duration": "0.12",
			"confidence": "0.570",
			"name": "just",
			"time": "18.28"
		},
		{
			"duration": "0.34",
			"confidence": "1.000",
			"name": "talk",
			"time": "18.48"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "about",
			"time": "18.82"
		},
		{
			"duration": "0.57",
			"confidence": "0.870",
			"name": "Tito's",
			"time": "19.63"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "adoption",
			"time": "20.29"
		},
		{
			"duration": "0.50",
			"confidence": "1.000",
			"name": "story",
			"time": "20.83"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "as",
			"time": "21.40"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "21.58"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "lot",
			"time": "21.61"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "21.85"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "21.97"
		},
		{
			"duration": "0.41",
			"confidence": "0.610",
			"name": "know",
			"time": "22.10"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "I",
			"time": "22.54"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "adopted",
			"time": "22.99"
		},
		{
			"duration": "0.48",
			"confidence": "0.960",
			"name": "Taito",
			"time": "23.71"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "24.19"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "24.28"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "while",
			"time": "24.52"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "ago",
			"time": "24.88"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "25.30"
		},
		{
			"duration": "0.24",
			"confidence": "0.960",
			"name": "he's",
			"time": "25.48"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "been",
			"time": "25.72"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "so",
			"time": "26.02"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "awesome",
			"time": "26.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "27.01"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "have",
			"time": "27.16"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "and",
			"time": "27.49"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "you've",
			"time": "27.58"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "seen",
			"time": "27.76"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "him",
			"time": "28.00"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "in",
			"time": "28.21"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "28.30"
		},
		{
			"duration": "0.50",
			"confidence": "1.000",
			"name": "videos",
			"time": "28.42"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "but",
			"time": "29.17"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "29.32"
		},
		{
			"duration": "0.20",
			"confidence": "0.550",
			"name": "haven't",
			"time": "29.45"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "really",
			"time": "29.83"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "talked",
			"time": "30.67"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "about",
			"time": "31.21"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "his",
			"time": "32.20"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "adoption",
			"time": "32.35"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "story",
			"time": "32.89"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "and",
			"time": "33.52"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "what",
			"time": "33.91"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "it",
			"time": "34.15"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "was",
			"time": "34.27"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "like",
			"time": "34.51"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "going",
			"time": "35.38"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "through",
			"time": "35.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "36.10"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "process",
			"time": "36.19"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "of",
			"time": "37.06"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "adopting",
			"time": "37.45"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "38.50"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "38.53"
		},
		{
			"duration": "0.38",
			"confidence": "0.750",
			"name": "dog",
			"time": "38.77"
		},
		{
			"duration": "0.15",
			"confidence": "0.970",
			"name": ".",
			"time": "39.15"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "39.37"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "really",
			"time": "39.46"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "wanted",
			"time": "39.76"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "40.06"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "make",
			"time": "40.21"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "40.45"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "video",
			"time": "40.66"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "for",
			"time": "41.29"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "people",
			"time": "41.56"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "who",
			"time": "42.04"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "are",
			"time": "42.31"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": "maybe",
			"time": "42.43"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "considering",
			"time": "42.70"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "adopting",
			"time": "43.36"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "or",
			"time": "44.14"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "maybe",
			"time": "44.32"
		},
		{
			"duration": "0.14",
			"confidence": "0.790",
			"name": "you're",
			"time": "44.59"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "44.74"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "curious",
			"time": "44.95"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "about",
			"time": "45.52"
		},
		{
			"duration": "0.55",
			"confidence": "0.530",
			"name": "Titos",
			"time": "46.21"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "story",
			"time": "46.78"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "and",
			"time": "47.41"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "how",
			"time": "47.74"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "we",
			"time": "48.04"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "got",
			"time": "48.25"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "to",
			"time": "48.73"
		},
		{
			"duration": "0.36",
			"confidence": "0.970",
			"name": "how",
			"time": "49.21"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "49.63"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "make",
			"time": "49.75"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "49.90"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "50.11"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "50.17"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bit",
			"time": "50.41"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "easier",
			"time": "50.59"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "50.92"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "understand",
			"time": "51.04"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "because",
			"time": "51.73"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "there",
			"time": "52.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "52.15"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "52.39"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "lot",
			"time": "52.48"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "going",
			"time": "52.93"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "on",
			"time": "53.23"
		},
		{
			"duration": "0.03",
			"confidence": "0.860",
			"name": ".",
			"time": "53.53"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I'm",
			"time": "53.56"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "53.71"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "53.83"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "break",
			"time": "53.92"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "this",
			"time": "54.37"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "down",
			"time": "54.76"
		},
		{
			"duration": "0.53",
			"confidence": "1.000",
			"name": "into",
			"time": "55.21"
		},
		{
			"duration": "0.19",
			"confidence": "0.480",
			"name": "you",
			"time": "55.74"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "before",
			"time": "55.96"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "during",
			"time": "56.83"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "57.34"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "after",
			"time": "57.58"
		},
		{
			"duration": "0.38",
			"confidence": "0.880",
			"name": "Tito's",
			"time": "58.22"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "adoption",
			"time": "58.60"
		},
		{
			"duration": "0.03",
			"confidence": "0.920",
			"name": ".",
			"time": "59.14"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "So",
			"time": "59.17"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "here",
			"time": "59.38"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "we",
			"time": "59.56"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "go",
			"time": "59.65"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": ".",
			"time": "59.89"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "This",
			"time": "59.95"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "60.10"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "all",
			"time": "60.31"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "about",
			"time": "60.52"
		},
		{
			"duration": "0.87",
			"confidence": "0.940",
			"name": "Mutato",
			"time": "60.84"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "61.71"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Adoption",
			"time": "63.17"
		},
		{
			"duration": "0.12",
			"confidence": "0.950",
			"name": "was",
			"time": "63.71"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "something",
			"time": "63.83"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "64.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I",
			"time": "64.34"
		},
		{
			"duration": "0.09",
			"confidence": "0.840",
			"name": "had",
			"time": "64.55"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "been",
			"time": "64.64"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "considering",
			"time": "64.82"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "for",
			"time": "65.48"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "65.72"
		},
		{
			"duration": "0.50",
			"confidence": "1.000",
			"name": "while",
			"time": "65.78"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "especially",
			"time": "66.32"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "after",
			"time": "67.07"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "67.97"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "mom",
			"time": "68.15"
		},
		{
			"duration": "0.49",
			"confidence": "1.000",
			"name": "took",
			"time": "68.75"
		},
		{
			"duration": "0.50",
			"confidence": "0.970",
			"name": "nugget",
			"time": "69.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "full",
			"time": "69.77"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "time",
			"time": "70.07"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "70.64"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "70.79"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "be",
			"time": "70.97"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "clear",
			"time": "71.12"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "which",
			"time": "71.51"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "71.78"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "think",
			"time": "71.90"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "72.11"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "72.20"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "clear",
			"time": "72.35"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "about",
			"time": "72.59"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "this",
			"time": "72.83"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "before",
			"time": "73.10"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "but",
			"time": "73.91"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "I've",
			"time": "74.09"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "seen",
			"time": "74.21"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "comments",
			"time": "74.84"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "75.41"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "people",
			"time": "75.59"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "saying",
			"time": "76.22"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "well",
			"time": "76.91"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "77.06"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "better",
			"time": "77.15"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "not",
			"time": "77.42"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "get",
			"time": "77.66"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "rid",
			"time": "77.87"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "of",
			"time": "78.05"
		},
		{
			"duration": "0.54",
			"confidence": "0.960",
			"name": "Taito",
			"time": "78.35"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "78.89"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "you",
			"time": "79.10"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "got",
			"time": "79.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "rid",
			"time": "79.46"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "79.61"
		},
		{
			"duration": "0.50",
			"confidence": "0.980",
			"name": "nugget",
			"time": "79.73"
		},
		{
			"duration": "0.14",
			"confidence": "0.630",
			"name": ".",
			"time": "80.23"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "That",
			"time": "80.45"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "is",
			"time": "80.63"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "not",
			"time": "80.96"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "what",
			"time": "81.38"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "happened",
			"time": "81.56"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "at",
			"time": "82.28"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "all",
			"time": "82.49"
		},
		{
			"duration": "0.19",
			"confidence": "0.930",
			"name": ".",
			"time": "82.97"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "83.18"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "was",
			"time": "83.30"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "perfectly",
			"time": "83.48"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "capable",
			"time": "84.08"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "84.80"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "still",
			"time": "84.95"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "taking",
			"time": "85.25"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "care",
			"time": "85.61"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "of",
			"time": "86.03"
		},
		{
			"duration": "0.58",
			"confidence": "1.000",
			"name": "Nugget",
			"time": "86.24"
		},
		{
			"duration": "0.09",
			"confidence": "0.590",
			"name": ".",
			"time": "86.82"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "But",
			"time": "87.02"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "my",
			"time": "87.32"
		},
		{
			"duration": "0.66",
			"confidence": "0.990",
			"name": "mom",
			"time": "87.53"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "bonded",
			"time": "88.22"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "with",
			"time": "88.94"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "nugget",
			"time": "89.33"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "89.78"
		},
		{
			"duration": "0.32",
			"confidence": "0.930",
			"name": "Nugget",
			"time": "89.97"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "bonded",
			"time": "90.32"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "with",
			"time": "91.10"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "her",
			"time": "91.28"
		},
		{
			"duration": "0.02",
			"confidence": "0.510",
			"name": ".",
			"time": "91.70"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "And",
			"time": "92.00"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "because",
			"time": "92.45"
		},
		{
			"duration": "0.24",
			"confidence": "0.980",
			"name": "she's",
			"time": "93.02"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "at",
			"time": "93.26"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "93.38"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "different",
			"time": "93.47"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "place",
			"time": "93.77"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "94.10"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "her",
			"time": "94.22"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "life",
			"time": "94.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "it",
			"time": "95.00"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "was",
			"time": "95.21"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "something",
			"time": "95.45"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "95.87"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "was",
			"time": "95.99"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "really",
			"time": "96.11"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "special",
			"time": "96.38"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "96.86"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "her",
			"time": "97.04"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "to",
			"time": "97.28"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "have",
			"time": "97.49"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "an",
			"time": "97.79"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "animal",
			"time": "97.91"
		},
		{
			"duration": "0.03",
			"confidence": "0.900",
			"name": ".",
			"time": "98.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "And",
			"time": "98.54"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "98.69"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "saw",
			"time": "98.84"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "how",
			"time": "99.68"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "much",
			"time": "99.95"
		},
		{
			"duration": "0.47",
			"confidence": "0.440",
			"name": "get",
			"time": "100.43"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "brought",
			"time": "100.94"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "to",
			"time": "101.39"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "her",
			"time": "101.99"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "life",
			"time": "102.56"
		},
		{
			"duration": "0.02",
			"confidence": "0.770",
			"name": ".",
			"time": "103.01"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "And",
			"time": "103.28"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "I",
			"time": "103.94"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "saw",
			"time": "104.51"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "how",
			"time": "104.75"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "happy",
			"time": "104.96"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "he",
			"time": "105.32"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "was",
			"time": "105.47"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "105.86"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "106.07"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "wanted",
			"time": "106.16"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "106.52"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "mom",
			"time": "106.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "106.97"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "107.09"
		},
		{
			"duration": "0.41",
			"confidence": "1.000",
			"name": "happy",
			"time": "107.21"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "and",
			"time": "107.63"
		},
		{
			"duration": "0.38",
			"confidence": "0.910",
			"name": "nuggets",
			"time": "107.78"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "be",
			"time": "108.17"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "happy",
			"time": "108.38"
		},
		{
			"duration": "0.03",
			"confidence": "0.890",
			"name": ".",
			"time": "108.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "108.89"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "still",
			"time": "108.98"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "get",
			"time": "109.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "109.40"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "see",
			"time": "109.55"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "him",
			"time": "109.85"
		},
		{
			"duration": "0.02",
			"confidence": "0.830",
			"name": ".",
			"time": "110.27"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "110.30"
		},
		{
			"duration": "0.16",
			"confidence": "0.910",
			"name": "still",
			"time": "110.45"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "get",
			"time": "110.63"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "110.78"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "spend",
			"time": "110.90"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "time",
			"time": "111.20"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "with",
			"time": "111.50"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "him",
			"time": "111.65"
		},
		{
			"duration": "0.11",
			"confidence": "0.700",
			"name": "and",
			"time": "112.17"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "because",
			"time": "112.34"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "112.76"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "mom",
			"time": "112.88"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "took",
			"time": "113.21"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "nugget",
			"time": "113.64"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "full",
			"time": "114.02"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "time",
			"time": "114.26"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "I",
			"time": "114.92"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "115.25"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "115.43"
		},
		{
			"duration": "0.30",
			"confidence": "0.850",
			"name": "had",
			"time": "115.55"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "this",
			"time": "115.88"
		},
		{
			"duration": "0.45",
			"confidence": "0.920",
			"name": "hole",
			"time": "116.18"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "116.63"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "my",
			"time": "116.75"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "life",
			"time": "117.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "117.47"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "I",
			"time": "117.62"
		},
		{
			"duration": "0.32",
			"confidence": "0.970",
			"name": "wanted",
			"time": "118.22"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "118.55"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "118.61"
		},
		{
			"duration": "0.33",
			"confidence": "0.760",
			"name": "body",
			"time": "118.85"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "119.18"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "myself",
			"time": "119.36"
		},
		{
			"duration": "0.03",
			"confidence": "0.940",
			"name": ".",
			"time": "119.93"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "120.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "120.11"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "really",
			"time": "120.26"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "open",
			"time": "120.53"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "to",
			"time": "121.01"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "adopting",
			"time": "121.34"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "a",
			"time": "122.15"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "dog",
			"time": "122.27"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "or",
			"time": "122.84"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "123.26"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "cat",
			"time": "123.35"
		},
		{
			"duration": "0.03",
			"confidence": "0.560",
			"name": ".",
			"time": "124.01"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "And",
			"time": "124.07"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "I",
			"time": "124.82"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "was",
			"time": "125.54"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "125.69"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "125.72"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "bit",
			"time": "125.96"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "more",
			"time": "126.32"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "hesitant",
			"time": "126.74"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "about",
			"time": "127.49"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "128.03"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "dog",
			"time": "128.12"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "128.69"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "because",
			"time": "128.90"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "I",
			"time": "129.44"
		},
		{
			"duration": "0.53",
			"confidence": "1.000",
			"name": "never",
			"time": "129.66"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "had",
			"time": "130.40"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "130.94"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "dog",
			"time": "131.00"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "ever",
			"time": "131.60"
		},
		{
			"duration": "0.60",
			"confidence": "0.990",
			"name": "before",
			"time": "132.08"
		},
		{
			"duration": "0.03",
			"confidence": "0.940",
			"name": ".",
			"time": "132.68"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "132.71"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "never",
			"time": "132.86"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "grew",
			"time": "133.10"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "up",
			"time": "133.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "with",
			"time": "133.82"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "dogs",
			"time": "134.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "in",
			"time": "134.54"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "my",
			"time": "134.69"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "household",
			"time": "134.90"
		},
		{
			"duration": "0.16",
			"confidence": "0.680",
			"name": ".",
			"time": "135.59"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "So",
			"time": "135.83"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "taking",
			"time": "136.37"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "care",
			"time": "136.82"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "137.12"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "137.27"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "dog",
			"time": "137.33"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "would",
			"time": "137.81"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "be",
			"time": "137.99"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "something",
			"time": "138.53"
		},
		{
			"duration": "1.08",
			"confidence": "1.000",
			"name": "completely",
			"time": "139.01"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "new",
			"time": "140.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "140.66"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "different",
			"time": "140.78"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "for",
			"time": "141.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "me",
			"time": "141.53"
		},
		{
			"duration": "0.09",
			"confidence": "0.970",
			"name": ".",
			"time": "141.83"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "141.92"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "really",
			"time": "142.04"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "wanted",
			"time": "142.37"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "to",
			"time": "143.03"
		},
		{
			"duration": "0.90",
			"confidence": "1.000",
			"name": "understand",
			"time": "143.45"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "more",
			"time": "144.35"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "what",
			"time": "144.92"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "145.22"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "was",
			"time": "145.37"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "like",
			"time": "145.70"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "to",
			"time": "146.15"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "have",
			"time": "146.45"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "146.72"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "dog",
			"time": "146.78"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "and",
			"time": "147.23"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "147.68"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "girlfriend",
			"time": "147.86"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "has",
			"time": "148.55"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "had",
			"time": "148.79"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "149.00"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "dog",
			"time": "149.09"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "for",
			"time": "149.78"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "about",
			"time": "150.29"
		},
		{
			"duration": "0.33",
			"confidence": "0.800",
			"name": "three",
			"time": "150.71"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "years",
			"time": "151.04"
		},
		{
			"duration": "0.08",
			"confidence": "0.820",
			"name": ".",
			"time": "151.52"
		},
		{
			"duration": "0.60",
			"confidence": "0.630",
			"name": "Loki",
			"time": "151.61"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "who",
			"time": "152.23"
		},
		{
			"duration": "0.25",
			"confidence": "0.850",
			"name": "you've",
			"time": "152.57"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "also",
			"time": "152.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "seen",
			"time": "153.14"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "in",
			"time": "153.38"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "153.47"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "videos",
			"time": "153.62"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "154.22"
		},
		{
			"duration": "0.51",
			"confidence": "0.800",
			"name": "Loki",
			"time": "154.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "is",
			"time": "154.88"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "also",
			"time": "155.09"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "155.66"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "rescue",
			"time": "155.72"
		},
		{
			"duration": "0.09",
			"confidence": "0.730",
			"name": ".",
			"time": "156.44"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "And",
			"time": "156.53"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "156.65"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "more",
			"time": "156.74"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "157.01"
		},
		{
			"duration": "0.30",
			"confidence": "0.880",
			"name": "spent",
			"time": "157.10"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "time",
			"time": "157.40"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "with",
			"time": "157.85"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "158.03"
		},
		{
			"duration": "0.67",
			"confidence": "1.000",
			"name": "girlfriend",
			"time": "158.18"
		},
		{
			"duration": "0.14",
			"confidence": "0.960",
			"name": "and",
			"time": "158.91"
		},
		{
			"duration": "0.60",
			"confidence": "0.570",
			"name": "therefore",
			"time": "159.14"
		},
		{
			"duration": "0.57",
			"confidence": "0.870",
			"name": "Loki",
			"time": "159.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "160.40"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "began",
			"time": "160.55"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "160.91"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "understand",
			"time": "161.06"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "161.81"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "161.87"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bit",
			"time": "162.11"
		},
		{
			"duration": "0.37",
			"confidence": "1.000",
			"name": "more",
			"time": "162.29"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "what",
			"time": "162.70"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "162.89"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "would",
			"time": "162.98"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "be",
			"time": "163.13"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "like",
			"time": "163.34"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "to",
			"time": "163.70"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "actually",
			"time": "164.00"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "have",
			"time": "164.36"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "my",
			"time": "164.60"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "own",
			"time": "164.84"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "dog",
			"time": "164.99"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "and",
			"time": "165.41"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "then",
			"time": "165.59"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I",
			"time": "165.98"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "started",
			"time": "166.16"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "to",
			"time": "166.70"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "ask",
			"time": "167.12"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "167.42"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "girlfriend",
			"time": "167.57"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "if",
			"time": "168.17"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "168.35"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "could",
			"time": "168.50"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "take",
			"time": "168.68"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "on",
			"time": "169.01"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "more",
			"time": "169.25"
		},
		{
			"duration": "0.99",
			"confidence": "1.000",
			"name": "responsibilities",
			"time": "169.49"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "with",
			"time": "170.48"
		},
		{
			"duration": "0.42",
			"confidence": "0.310",
			"name": "Loki",
			"time": "170.66"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "so",
			"time": "171.08"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "171.74"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "would",
			"time": "171.86"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "watch",
			"time": "171.98"
		},
		{
			"duration": "0.54",
			"confidence": "0.720",
			"name": "Loki",
			"time": "172.37"
		},
		{
			"duration": "0.04",
			"confidence": "0.590",
			"name": ".",
			"time": "172.93"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "When",
			"time": "172.97"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "173.30"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "girlfriend",
			"time": "173.42"
		},
		{
			"duration": "0.41",
			"confidence": "0.950",
			"name": "wasn't",
			"time": "173.90"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "around",
			"time": "174.38"
		},
		{
			"duration": "0.21",
			"confidence": "0.960",
			"name": "or",
			"time": "174.92"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "she",
			"time": "175.13"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "was",
			"time": "175.31"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "doing",
			"time": "175.73"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "something",
			"time": "176.15"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "I",
			"time": "177.08"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "would",
			"time": "177.65"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "offer",
			"time": "178.01"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "178.37"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "take",
			"time": "178.52"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "her",
			"time": "178.79"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "out",
			"time": "178.97"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "on",
			"time": "179.27"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "walks",
			"time": "179.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "180.02"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "feed",
			"time": "180.17"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "her",
			"time": "180.59"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "181.13"
		},
		{
			"duration": "0.26",
			"confidence": "0.960",
			"name": "just",
			"time": "181.25"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "do",
			"time": "181.52"
		},
		{
			"duration": "0.13",
			"confidence": "0.850",
			"name": "the",
			"time": "181.88"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "things",
			"time": "182.03"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "that",
			"time": "182.42"
		},
		{
			"duration": "0.17",
			"confidence": "0.870",
			"name": "you",
			"time": "182.54"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "182.71"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/dog_adoption_audio.json
// module id = 25
// module chunks = 0